"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendToFormV3 = sendToFormV3;
exports.saveToV3ExtendedProfile = saveToV3ExtendedProfile;
exports.retriveV3ExtendedProfile = retriveV3ExtendedProfile;
exports.retriveV3ExtendedProfileV2 = retriveV3ExtendedProfileV2;
const axios_1 = __importDefault(require("axios"));
const profile_processor_1 = require("./profile.processor");
function createCookie(cookieName, cookieValue, ttlInDays) {
    let expires = '';
    if (ttlInDays) {
        const date = new Date();
        // eslint-disable-next-line no-mixed-operators
        date.setTime(date.getTime() + ttlInDays * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = cookieName + '=' + (cookieValue || '') + expires + '; path=/';
    return true;
}
function saveCookie(gigyaResponse) {
    return createCookie('UnileverId', gigyaResponse.data.UnileverId, 30);
}
function saveToFormV3Profile(profileData, api, profileStore) {
    return __awaiter(this, void 0, void 0, function* () {
        const PROFILE_STORE_API_URL = profileStore[api].url;
        const PROFILE_STORE_API_KEY = profileStore[api].apiKey;
        let headers = { 'x-api-key': PROFILE_STORE_API_KEY, 'Content-Type': 'application/json' };
        if (PROFILE_STORE_API_URL.includes('save')) {
            const jwtToken = profileStore[api].jwtToken;
            headers = { 'x-api-key': PROFILE_STORE_API_KEY, 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` };
        }
        try {
            const newsLetterResponse = yield (0, axios_1.default)({
                method: 'post',
                url: PROFILE_STORE_API_URL,
                headers,
                data: Object.assign({}, profileData),
            });
            saveCookie(newsLetterResponse);
            return newsLetterResponse;
        }
        catch (error) {
            throw error.response;
        }
    });
}
function sendToFormV3(profileData, api, header, locale, profileStore, genderArray) {
    return __awaiter(this, void 0, void 0, function* () {
        const { availableGenderArray, supportedGenderArray } = genderArray;
        const headerData = header;
        let localeData;
        if (locale)
            localeData = getFormV3LocaleData(locale);
        const formV3RequestData = {
            profile: Object.assign({ header: Object.assign(Object.assign({}, headerData), localeData) }, (profileData.eps && { eps: profileData.eps })),
        };
        formV3RequestData.profile['contactDetail'] = profileData.contactDetail;
        formV3RequestData.profile['consumerIdentity'] = profileData.consumerIdentity;
        if (profileData.consumerIdentity['gender']) {
            const gender = profileData.consumerIdentity['gender'];
            if (Object.keys(availableGenderArray).includes(gender)) {
                formV3RequestData.profile['consumerIdentity']['gender'] = availableGenderArray[gender];
            }
            else if (supportedGenderArray.includes(gender)) {
                formV3RequestData.profile['consumerIdentity']['gender'] = gender;
            }
        }
        formV3RequestData.profile['optInStatus'] = profileData.consent;
        if (profileData === null || profileData === void 0 ? void 0 : profileData.additionalSubscription) {
            formV3RequestData.profile['additionalSubscription'] = profileData.additionalSubscription;
        }
        if (profileData.results) {
            formV3RequestData.profile['questionAndAnswers'] = (0, profile_processor_1.formatResultsForFormV3Request)(profileData.results.quiz, profileData.results.skin, profileData.skinQuesIdMapping);
        }
        console.log('[profile.service.saveProfile.formV3RequestData] ', formV3RequestData);
        try {
            return yield saveToFormV3Profile(formV3RequestData, api, profileStore);
        }
        catch (error) {
            console.log('[profile.service.saveProfile.formV3.error]', error);
            throw error;
        }
    });
}
function getFormV3LocaleData(localeData) {
    try {
        return localeData.split('-').reduce(function (result, item) {
            item.toLowerCase() === item ? (result['isoLanguage'] = item.toUpperCase()) : (result['isoCountry'] = item);
            return result;
        }, {});
    }
    catch (error) {
        console.log(error);
    }
}
function saveToV3ExtendedProfile(epData, api, header, locale, profileStore) {
    return __awaiter(this, void 0, void 0, function* () {
        if (api) {
            const headerData = header;
            const localeData = getFormV3LocaleData(locale);
            const extendedProfileData = {
                profile: {
                    header: Object.assign(Object.assign({}, headerData), localeData),
                    eps: Object.assign({}, epData),
                },
            };
            try {
                return yield sendToExtendedProfile(extendedProfileData, api, profileStore);
            }
            catch (error) {
                throw error;
            }
        }
    });
}
function retriveV3ExtendedProfile(jwtToken, api, header, locale, profileStore) {
    return __awaiter(this, void 0, void 0, function* () {
        const headerData = header;
        const localeData = getFormV3LocaleData(locale);
        const extendedProfileData = {
            profile: {
                header: Object.assign(Object.assign({}, headerData), localeData),
            },
        };
        try {
            return yield getFromExtendedProfile(extendedProfileData, jwtToken, api, profileStore);
        }
        catch (error) {
            throw error;
        }
    });
}
function retriveV3ExtendedProfileV2(jwtToken, api, header, locale, profileStore) {
    return __awaiter(this, void 0, void 0, function* () {
        const headerData = header;
        const localeData = getFormV3LocaleData(locale);
        const extendedProfileData = {
            profile: {
                header: Object.assign(Object.assign({}, headerData), localeData),
                profileStores: ['CPS', 'EPS'],
                extendedProfileStoreGroups: ['appPersonalisation'],
            },
        };
        try {
            return yield getFromExtendedProfile(extendedProfileData, jwtToken, api, profileStore);
        }
        catch (error) {
            throw error;
        }
    });
}
function sendToExtendedProfile(extendedProfileData, api, profileStore) {
    return __awaiter(this, void 0, void 0, function* () {
        const EXTENDED_PROFILE_STORE_API_URL = profileStore[api].epsUrl;
        const PROFILE_STORE_API_KEY = profileStore[api].apiKey;
        try {
            const epsResponse = yield (0, axios_1.default)({
                method: 'post',
                url: `${EXTENDED_PROFILE_STORE_API_URL}/save`,
                headers: { 'x-api-key': PROFILE_STORE_API_KEY, 'Content-Type': 'application/json' },
                data: Object.assign({}, extendedProfileData),
            });
            return epsResponse;
        }
        catch (error) {
            throw error.response;
        }
    });
}
function getFromExtendedProfile(profileData, jwtToken, api, profileStore) {
    return __awaiter(this, void 0, void 0, function* () {
        const PROFILE_STORE_API_KEY = profileStore[api].apiKey;
        const EXTENDED_PROFILE_STORE_API_URL = profileStore[api].epsUrl;
        return new Promise((resolve, reject) => {
            (0, axios_1.default)({
                method: 'post',
                url: `${EXTENDED_PROFILE_STORE_API_URL}/retrieve/v2`,
                headers: {
                    'x-api-key': PROFILE_STORE_API_KEY,
                    'Authorization': `Bearer ${jwtToken}`,
                    'Content-Type': 'application/json',
                },
                data: Object.assign({}, profileData),
            })
                .then(newsLetterResponse => {
                resolve(newsLetterResponse);
            })
                .catch(error => {
                reject(error);
            });
        });
    });
}
